import { FONT_FAMILIES as b, DISALLOWED_COLOR_VALUES as m, BLOCK_CLASSES as C } from "../../constants.js";
import { defineAttrs as h } from "../../utils/typed-attrs.js";
import c from "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
const $ = h({
  fontFamily: { default: "" },
  fontColor: { default: "" },
  backgroundColor: { default: "" },
  paddingTop: { default: "" },
  paddingBottom: { default: "" },
  paddingLeft: { default: "" },
  paddingRight: { default: "" },
  borderRadius: { default: "" },
  borderColor: { default: "" },
  borderWidth: { default: "" },
  borderStyle: { default: "" }
});
function y(a) {
  let s = "";
  return a.attrs.paddingTop && (s += `padding-top: ${a.attrs.paddingTop}; `), a.attrs.paddingBottom && (s += `padding-bottom: ${a.attrs.paddingBottom}; `), a.attrs.paddingLeft && (s += `padding-left: ${a.attrs.paddingLeft}; `), a.attrs.paddingRight && (s += `padding-right: ${a.attrs.paddingRight}; `), s;
}
function D(a) {
  a.attrs = Object.assign({}, a.attrs, {
    fontFamily: { default: "" },
    fontColor: { default: "" },
    backgroundColor: { default: "" },
    paddingTop: { default: "" },
    paddingBottom: { default: "" },
    paddingLeft: { default: "" },
    paddingRight: { default: "" },
    borderRadius: { default: "" },
    borderColor: { default: "" },
    borderWidth: { default: "" },
    borderStyle: { default: "" }
  }), a.parseDOM?.forEach(function(t) {
    const i = t.getAttrs;
    t.getAttrs = (r) => {
      const o = {};
      i && Object.assign(o, i(r));
      const {
        fontFamily: d,
        color: e,
        borderRadius: l,
        paddingTop: f,
        paddingBottom: g,
        paddingLeft: u,
        paddingRight: p
      } = r?.style || {};
      if (d && b.includes(d) && Object.assign(o, { fontFamily: d }), e && !m.includes(e) && c(e).isValid()) {
        const n = c(e).toHexString();
        Object.assign(o, { fontColor: n });
      }
      if ((f || u || p || g) && Object.assign(o, { paddingTop: f, paddingLeft: u, paddingRight: p, paddingBottom: g }), l && Object.assign(o, { borderRadius: l }), r.classList.contains(C.button) || r.classList.contains("intercom-interblocks-button")) {
        const n = L(r.firstChild);
        Object.assign(o, n);
      }
      return o;
    };
  });
  const s = a.toDOM;
  return a.toDOM = (t) => {
    if (!s)
      throw new Error("must specify a toDOM method");
    const i = s(t);
    if (!Array.isArray(i) || i.length < 2)
      throw new Error("must specify at least two elements in output spec");
    i[1] === 0 && i.splice(1, 0, {});
    const r = i[1], o = i[2] ? i[2][1] : {};
    return r.style ??= "", o.style ??= "", t.attrs.fontFamily && (r.style += `font-family: ${t.attrs.fontFamily}; `), t.attrs.borderRadius && (o.style += `border-radius: ${t.attrs.borderRadius}; `), t.attrs.fontColor && (r.style += `color: ${t.attrs.fontColor}; `), t.attrs.backgroundColor && (t.attrs.responsive ? o.style += `background-color: ${t.attrs.backgroundColor}; ` : t.type.name !== "button" && !t.attrs.container && (r.style += `background-color: ${t.attrs.backgroundColor}; `)), t.attrs.borderColor && (r.style += `border-color: ${t.attrs.borderColor}; `), O(t) && (t.attrs.container ? r.style += y(t) : (o.style += y(t), t.attrs.responsive && (o.style += "border-collapse: separate; "))), r.style = r.style.trim(), o.style = o.style.trim(), r.style === "" && (r.style = null), o.style === "" && (o.style = null), i;
  }, a;
}
function L(a) {
  const {
    paddingTop: s,
    paddingRight: t,
    paddingLeft: i,
    paddingBottom: r,
    borderRadius: o,
    borderColor: d,
    borderWidth: e,
    borderStyle: l
  } = a?.style || {};
  return {
    paddingTop: s,
    paddingRight: t,
    paddingLeft: i,
    paddingBottom: r,
    borderRadius: o,
    borderColor: d,
    borderWidth: e,
    borderStyle: l
  };
}
function O(a) {
  const { paddingTop: s, paddingRight: t, paddingLeft: i, paddingBottom: r } = a.attrs;
  return !!(s || t || i || r);
}
export {
  y as getPaddingStyles,
  D as stylable,
  $ as stylableAttrs
};
